export const summaryPageSelector = ({ config }) => ({
  portalRedesignEnabled: config.portalRedesignEnabled,
});
